import React from "react";

const EmptyState = ({ icon, title, description, action, className = "" }) => {
    return (
        <div
            className={`flex flex-col items-center justify-center rounded-2xl border border-dashed border-ink-200 bg-white py-12 px-6 text-center ${className}`}
        >
            {icon && (
                <div
                    className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-ink-50 text-ink-500"
                    aria-hidden="true"
                >
                    {icon}
                </div>
            )}
            {title && <h3 className="text-lg font-semibold text-ink-900">{title}</h3>}
            {description && <p className="mt-1 max-w-sm text-sm text-ink-500">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
};

export default EmptyState;
